var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M3 13c0-1.51.336-2.991 1.154-4.122C5.004 7.705 6.31 7 8 7c2.026 0 3.462 1.01 4.252 2.542a1 1 0 11-1.777.916C10.012 9.562 9.245 9 8 9c-1.07 0-1.765.415-2.226 1.05C5.284 10.73 5 11.75 5 13c0 1.25.283 2.27.774 2.95C6.234 16.584 6.93 17 8 17c1.245 0 2.012-.562 2.475-1.458a1 1 0 011.777.916C11.462 17.991 10.026 19 8 19c-1.69 0-2.996-.705-3.846-1.878C3.336 15.992 3 14.511 3 13zM14.2 6.9a1 1 0 011.4-.2L17 7.75l1.4-1.05a1 1 0 111.2 1.6l-2 1.5a1 1 0 01-1.2 0l-2-1.5a1 1 0 01-.2-1.4zM10.707 3.707a1 1 0 00-1.414-1.414l-2 2a1 1 0 001.414 1.414l2-2zM19.894 11.553A1 1 0 0019 11h-4.5a1 1 0 100 2H17l-3.3 4.4a1 1 0 00.8 1.6H19a1 1 0 100-2h-2.5l3.3-4.4a1 1 0 00.094-1.047z",
          fill: "#000",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }